import React from "react";
import "../../styles/PaymentStats.css";

const PaymentStats = ({ stats }) => {
    return (
        <div className="payment-stats">

            <div className="payment-stat-card">
                <h4>Total Payments</h4>
                <h2>{stats.total}</h2>
            </div>

            <div className="payment-stat-card">
                <h4>Successful</h4>
                <h2>{stats.successful}</h2>
            </div>

            <div className="payment-stat-card">
                <h4>Pending</h4>
                <h2>{stats.pending}</h2>
            </div>

            <div className="payment-stat-card">
                <h4>Refunded</h4>
                <h2>{stats.refunded}</h2>
            </div>

            <div className="payment-stat-card">
                <h4>Total Revenue</h4>
                <h2>₹{stats.revenue}</h2>
            </div>

        </div>
    );
};

export default PaymentStats;